import sanitizeHtml from 'sanitize-html';
import { SVG_DOWNLOAD, COPILOT_CHAT_STREAM_IDENTIFIERS } from './constants';

// DOM element creation utilities
export const createInfoBox = ({ container, isChart, isTable, id, t }) => {
    container.classList.add('dana-chat-info');

    const header = document.createElement('div');
    header.classList.add('dana-chat-info__header');

    const title = document.createElement('div');
    title.classList.add('dana-chat-info__header__title');
    title.innerHTML = sanitizeHtml(isChart ? t('label_report') : t('label_table'));

    const actionsContainer = document.createElement('div');
    actionsContainer.classList.add('dana-chat-info__header__actions');

    // Create action
    const divAction = document.createElement('div');
    divAction.classList.add('dana-chat-info__header__actions__action');

    const parser = new DOMParser();
    const svgDocument = parser.parseFromString(SVG_DOWNLOAD, 'image/svg+xml');
    const svgElement = svgDocument.documentElement;

    const identifier = isChart
        ? COPILOT_CHAT_STREAM_IDENTIFIERS.chart
        : COPILOT_CHAT_STREAM_IDENTIFIERS.table;
    svgElement.setAttribute(identifier, id);
    svgElement.classList.add('dana-chat-info__header__action-icon');

    divAction.appendChild(svgElement);
    actionsContainer.appendChild(divAction);

    header.appendChild(title);
    header.appendChild(actionsContainer);

    const body = document.createElement('div');
    body.classList.add('dana-chat-info__body');
    if (isChart) body.classList.add('dana-chat-info__body__chart');
    if (isTable) body.classList.add('dana-chat-info__body__table');

    container.appendChild(header);
    container.appendChild(body);

    return body;
};

// Table creation utility
export const createTable = (tableData, replaceForDetail) => {
    if (!tableData?.length) return null;

    const table = document.createElement('table');
    table.classList.add('dana-chat-info__table');
    Object.assign(table.style, {
        width: '100%',
        borderCollapse: 'collapse',
        tableLayout: 'auto',
    });

    const headers = Object.keys(tableData[0]);

    // Calculate column widths more efficiently
    const columnMaxWidths = headers.reduce((acc, header) => {
        acc[header] =
            Math.max(
                header.length,
                ...tableData.map((row) => row[header]?.toString().length || 0),
            ) * 20;
        return acc;
    }, {});

    // Create header row
    const headerRow = document.createElement('tr');
    headers.forEach((headerText) => {
        const headerCell = document.createElement('th');
        headerCell.classList.add('dana-chat-info__table__header-cell');
        headerCell.textContent = headerText;
        headerCell.style.width = `${columnMaxWidths[headerText]}px`;
        headerRow.appendChild(headerCell);
    });
    table.appendChild(headerRow);

    // Create data rows
    tableData.forEach((rowData) => {
        const row = document.createElement('tr');
        headers.forEach((header) => {
            const cell = document.createElement('td');
            cell.classList.add('dana-chat-info__table__row-cell');
            const cellValue = rowData[header] || '';
            cell.innerHTML = cellValue
                .toString()
                .replace(/\[fm_detail=(['"])([^'"]*)\1\]/g, replaceForDetail());
            cell.style.width = `${columnMaxWidths[header]}px`;
            row.appendChild(cell);
        });
        table.appendChild(row);
    });

    return table;
};

// CSV conversion utility
export const convertTableToCSV = (table, removeTags) => {
    if (!table) return '';

    const rows = Array.from(table.querySelectorAll('tr'));
    return rows
        .map((row) => {
            const cols = Array.from(row.querySelectorAll('td,th'));
            return cols.map((col) => removeTags(col.innerHTML || '')).join(',');
        })
        .join('\n');
};

// Download utilities
export const downloadFile = (content, filename, type = 'text/csv') => {
    const blob = new Blob([content], { type });
    const url = URL.createObjectURL(blob);
    const downloadLink = document.createElement('a');
    downloadLink.href = url;
    downloadLink.download = filename;
    downloadLink.click();
    URL.revokeObjectURL(url);
};

export const downloadImage = (imageBase64, filename) => {
    const a = document.createElement('a');
    a.href = imageBase64;
    a.download = filename;
    a.click();
};
